import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    talentRequisitions: [],
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    total: 0,
    selectedRow: null,
  },
  actions,
  mutations,
};
